(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["package-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initPackagePicker(picker) {
      var cards = picker.querySelectorAll('.package-picker__card');
      var sticky = picker.parentElement
        ? picker.parentElement.querySelector('[data-picker-sticky]')
        : null;
      var stickyTitle = sticky && sticky.querySelector('.package-picker-sticky__title');
      var stickyPrice = sticky && sticky.querySelector('.package-picker-sticky__price');
      var stickyCta   = sticky && sticky.querySelector('[data-sticky-atc]');

      // Position sticky below the site header
      function setStickyOffset() {
        if (!sticky) return;
        var header = document.querySelector('.header-wrapper, .shopify-section-group-header-group, header[role="banner"]');
        sticky.style.top = header ? header.offsetHeight + 'px' : '0';
      }
      setStickyOffset();
      window.addEventListener('resize', setStickyOffset);

      function updateStickyContent(card) {
        if (!stickyTitle || !stickyPrice) return;
        stickyTitle.textContent = card.dataset.variantTitle || '';
        stickyPrice.textContent = card.dataset.variantPrice || '';
      }

      function selectCard(card) {
        if (card.getAttribute('aria-disabled') === 'true') return;

        var variantId = card.dataset.variantId;

        // 1. Update visual state
        cards.forEach(function (c) {
          c.classList.remove('package-picker__card--selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('package-picker__card--selected');
        card.setAttribute('aria-checked', 'true');

        updateStickyContent(card);

        var section = picker.closest('.shopify-section') || document;

        // 2. Click the native variant-picker input — Horizon renders radios as
        //    input[value="<id>"] inside .variant-picker (buttons style uses label+radio).
        //    Use .click() so Horizon's own event listeners fire naturally.
        var nativeEl = section.querySelector(
          '.variant-picker input[value="' + variantId + '"],' +
          '.variant-picker input[data-variant-id="' + variantId + '"]'
        );
        if (nativeEl) {
          nativeEl.click();
        } else {
          // 3. Fallback for Bundles-app or non-standard forms: update the hidden
          //    variant-id input that Shopify's product form reads on submit.
          var idInput =
            section.querySelector('input[name="id"][ref="variantId"]') ||
            section.querySelector('product-form input[name="id"]') ||
            section.querySelector('form[action*="/cart/add"] input[name="id"]') ||
            section.querySelector('input[name="id"]');
          if (idInput) {
            idInput.value = variantId;
            ['input', 'change'].forEach(function (evtName) {
              idInput.dispatchEvent(new Event(evtName, { bubbles: true }));
            });
          }
        }

        // 4. Broadcast variant:change so price displays, galleries and any
        //    Bundles-app listeners can react to the new selection.
        document.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            variantId: parseInt(variantId, 10),
            sectionId: picker.dataset.sectionId
          }
        }));

        // 5. Update URL so page-reload restores the selection
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url.toString());
      }

      // Initialise sticky content from the already-selected card
      var initialSelected = picker.querySelector('.package-picker__card--selected');
      if (initialSelected) updateStickyContent(initialSelected);

      // Click handler
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          selectCard(card);
        });
      });

      // Sticky CTA → find and click the real add-to-cart button
      if (stickyCta) {
        stickyCta.addEventListener('click', function () {
          var section = picker.closest('.shopify-section') || document;
          var atcBtn = section.querySelector('[name="add"], .product-form__submit, [data-type="add-to-cart-button"]');
          if (atcBtn) {
            atcBtn.click();
          }
        });
      }

      // Keyboard navigation (ARIA radiogroup pattern)
      picker.addEventListener('keydown', function (e) {
        var allCards = Array.from(cards);
        var current = picker.querySelector('.package-picker__card--selected');
        var idx = allCards.indexOf(current);

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var next = allCards[idx + 1] || allCards[0];
          selectCard(next);
          next.focus();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = allCards[idx - 1] || allCards[allCards.length - 1];
          selectCard(prev);
          prev.focus();
        }
      });

      // Show/hide sticky strip via IntersectionObserver
      if (sticky && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              sticky.classList.toggle('package-picker-sticky--visible', !entry.isIntersecting);
              sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
            });
          },
          { threshold: 0 }
        );
        observer.observe(picker);
      }

      // Sync card selection when variant changes externally (e.g. URL param or
      // another UI element). Guard against reacting to our own dispatches by
      // checking whether the incoming sectionId matches ours.
      document.addEventListener('variant:change', function (e) {
        if (!e.detail || !e.detail.variantId) return;
        // Skip events we ourselves dispatched for this picker
        if (e.detail.sectionId && e.detail.sectionId === picker.dataset.sectionId) return;
        var changed = String(e.detail.variantId);
        cards.forEach(function (c) {
          var isMatch = c.dataset.variantId === changed;
          c.classList.toggle('package-picker__card--selected', isMatch);
          c.setAttribute('aria-checked', isMatch ? 'true' : 'false');
          if (isMatch) updateStickyContent(c);
        });
      });
    }

    document.querySelectorAll('.package-picker').forEach(initPackagePicker);

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.package-picker').forEach(initPackagePicker);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
